import { memo, useMemo } from 'react';
import { invertObj } from 'ramda';

import { mapFileExtByMimeType } from 'CorePackage/MainModule/constants/mapFileExtByMimeType';
import docx from 'assets/filetype-docx.png';
import xlsx from 'assets/filetype-xlsx.png';
import doc from 'assets/filetype-doc.png';
import ods from 'assets/filetype-ods.png';
import jpeg from 'assets/filetype-jpeg.png';
import pdf from 'assets/filetype-pdf.png';
import png from 'assets/filetype-png.png';
import zip from 'assets/filetype-zip.png';
import rar from 'assets/filetype-rar.png';
import xml from 'assets/filetype-xml.png';
import sig from 'assets/filetype-sig.png';

import styles from './IconFile.module.scss';

const iconAssets = new Map([
  ['docx', docx],
  ['xlsx', xlsx],
  ['doc', doc],
  ['ods', ods],
  ['jpeg', jpeg],
  ['jpg', jpeg],
  ['pdf', pdf],
  ['png', png],
  ['zip', zip],
  ['rar', rar],
  ['xml', xml],
  ['sig', sig],
]);

const mapIconPath: IMapIconPath = { ...invertObj(mapFileExtByMimeType), 'application/x-zip-compressed': 'zip' };

type IMapIconPath = Record<string, string>;

interface IFileIconProps {
  width?: 'small';
  margin?: 'left' | 'right';
  type?: 'side' | 'check';
  fileName: string;
  fileType?: string;
}

export const IconFile = memo(({ width, margin, fileName, fileType, type }: IFileIconProps) => {
  const iconAttributes = {
    ...(width === 'small' && { 'data-width-small': true }),
    ...(margin === 'left' && { 'data-margin-left': true }),
    ...(margin === 'right' && { 'data-margin-right': true }),
    ...(type === 'side' && { 'data-side': true }),
  };
  const iconStyle = useMemo(() => {
    const iconByMimeType = fileType ? mapIconPath[fileType] : undefined;

    return iconByMimeType ?? fileName.split('.').pop();
  }, [fileName, fileType]);
  const image = useMemo(() => `url(${iconAssets.get(String(iconStyle).toLocaleLowerCase())})`, [iconStyle]);

  return <div className={styles.Icon} style={{ backgroundImage: image }} {...iconAttributes} />;
});
